export default "__VITE_ASSET__ZoCvOazT__"